import * as Yup from "yup";

export const noteCommentValidationSchema = Yup.object().shape({
  comment: Yup.string().required("Comment is required."),
});
